import * as angular from 'angular';

import { IRequestService } from '../request.service';
import { ActionResponseDto, Ticket, IDictionaryAssignableStatuses, TicketsWithAssignableStatuses, TicketCounts } from '../../models';

export interface ITicketService {
    getAll(): angular.IPromise<Ticket[]>;
    getAll(force: boolean): angular.IPromise<Ticket[]>;
    getChildren(): angular.IPromise<Ticket[]>;
    getChildren(force: boolean): angular.IPromise<Ticket[]>;
    getChildrenWithAssignableStatuses(): angular.IPromise<TicketsWithAssignableStatuses>;
    getChildrenWithAssignableStatuses(force: boolean): angular.IPromise<TicketsWithAssignableStatuses>;
    addMany(entities: Ticket[]): angular.IPromise<Ticket[]>;
    updateMany(entities: Ticket[]): angular.IPromise<Ticket[]>;
    getAssignableStatuses(idList: number[], forChildren: boolean): angular.IPromise<IDictionaryAssignableStatuses>;
    getTicketCounts(): angular.IPromise<TicketCounts>;
    getTicketCounts(force: boolean): angular.IPromise<TicketCounts>;
}

export class TicketService implements ITicketService {

    static serviceId = 'ticketService';
    private _controllerUrl = 'ticket';

    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }

    getAll(): angular.IPromise<Ticket[]>;
    getAll(force: boolean): angular.IPromise<Ticket[]>;
    getAll(force?: boolean): angular.IPromise<Ticket[]> {
        const url = this._controllerUrl;
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1<ActionResponseDto<Ticket>>(url)
            .then(data => {
                if (data.isSuccessful) {
                    return data.items;
                } else {
                    throw data.message;
                }
            })
            .catch(error => {
                return error;
            });
    }

    getChildren(): angular.IPromise<Ticket[]>;
    getChildren(force: boolean): angular.IPromise<Ticket[]>;
    getChildren(force?: boolean): angular.IPromise<Ticket[]> {
        const url = `${this._controllerUrl}/children`;
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1<ActionResponseDto<Ticket>>(url)
            .then(data => {
                if (data.isSuccessful) {
                    return data.items;
                } else {
                    throw data.message;
                }
            })
            .catch(error => {
                return error;
            });
    }

    getChildrenWithAssignableStatuses(): angular.IPromise<TicketsWithAssignableStatuses>;
    getChildrenWithAssignableStatuses(force: boolean): angular.IPromise<TicketsWithAssignableStatuses>;
    getChildrenWithAssignableStatuses(force?: boolean): angular.IPromise<TicketsWithAssignableStatuses> {
        const url = `${this._controllerUrl}/childrenWithAssignableStatuses`;
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1<ActionResponseDto<TicketsWithAssignableStatuses>>(url)
            .then(data => {
                if (data.isSuccessful) {
                    return data.items[0];
                } else {
                    throw data.message;
                }
            })
            .catch(error => {
                return error;
            });
    }

    addMany(entities: Ticket[]): angular.IPromise<Ticket[]> {
        const url = `${this._controllerUrl}/addMany`;
        this._requestService.cleanCacheAtV1(url);
        const data = JSON.stringify(entities);
        return this._requestService.postAtV1<ActionResponseDto<Ticket>>(url, data)
            .then(data => {
                if (data.isSuccessful) {
                    return data.items;
                } else {
                    throw data.message;
                }
            });
    }

    updateMany(entities: Ticket[]): angular.IPromise<Ticket[]> {
        const url = `${this._controllerUrl}/updateMany`;
        this._requestService.cleanCacheAtV1(url);
        const data = JSON.stringify(entities);
        return this._requestService.postAtV1<ActionResponseDto<Ticket>>(url, data)
            .then(data => {
                if (data.isSuccessful) {
                    return data.items;
                } else {
                    throw data.message;
                }
            }).catch(error => {
                return error;
            });
    }

    // Get assignable statuses
    getAssignableStatuses(idList: number[], forChildren: boolean): angular.IPromise<IDictionaryAssignableStatuses> {
        const url = `${this._controllerUrl}/getAssignableStatuses/${forChildren}`;
        this._requestService.cleanCacheAtV1(url);
        const data = JSON.stringify(idList);
        return this._requestService.postAtV1<IDictionaryAssignableStatuses>(url, data)
            .then(data => {
                return data;
            });
    }

    getTicketCounts(): angular.IPromise<TicketCounts>;
    getTicketCounts(force: boolean): angular.IPromise<TicketCounts>;
    getTicketCounts(force?: boolean): angular.IPromise<TicketCounts> {
        const url = `${this._controllerUrl}/getTicketCounts/`;
        this._requestService.cleanCacheAtV1(url);
        return this._requestService.getAtV1<TicketCounts>(url)
            .then(data => {
                return data;
            });
    }
}